<template>
    <CardPage :section="section" :page="page">
        <template v-slot:image>
            <div class="bio-image">
                <ResponsiveImage flex="xs12" :src="image" :min-height="200" :alt="name"></ResponsiveImage>
            </div>
        </template>
        <p class="title primary bio-title pa-3">{{ name }}</p>
        <p>{{ bio }}</p>
    </CardPage>
</template>

<script>
export default {
    props: {
        section: {
            type: Number,
            required: true
        },
        page: {
            type: Number,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    computed: {
        image() {
            return this.$store.get(`section2/quiz@${this.index}.image`);
        },
        name() {
            return this.$store.get(`section2/quiz@${this.index}.name`);
        },
        bio() {
            return this.$store.get(`section2/quiz@${this.index}.bio`);
        }
    }
};
</script>

<style scoped>
.bio-image {
    margin: -4em 0;
}
.bio-title {
    margin: 1em -0.8em;
    color: #ffffff;
    text-align: center;
}
</style>
